import { ACCEPTANCE_SOURCE } from '~/utilities/legalDocuments'

// Computed key so dotenv-webpack never inlines the secret into the browser bundle (see utilities/axios.js).
const CLIENT_IP_SECRET_KEY = 'WINIT_CLIENT_IP_SECRET'

const firstHeaderValue = value => (Array.isArray(value) ? value[0] : value || '').split(',')[0].trim()

export const getClientIp = req => {
  const headers = req?.headers || {}
  return firstHeaderValue(headers['x-forwarded-for']) || firstHeaderValue(headers['x-real-ip'])
}

// Headers for server-side calls made to the backend on behalf of the browser user (SSR only).
export const forwardedClientHeaders = req => {
  if (typeof window !== 'undefined') return {}
  const secret = process.env[CLIENT_IP_SECRET_KEY]
  const clientIp = getClientIp(req)
  if (!secret || !clientIp) return {}
  const headers = {
    'X-Winit-Client-IP': clientIp,
    'X-Winit-Proxy-Secret': secret,
    'X-Winit-Source': ACCEPTANCE_SOURCE,
  }
  const userAgent = req.headers['user-agent']
  if (userAgent) headers['X-Winit-Client-User-Agent'] = userAgent
  return headers
}
